import { render, staticRenderFns } from "./OkidokiContractDialog.vue?vue&type=template&id=5248a650&scoped=true"
import script from "./OkidokiContractDialog.vue?vue&type=script&lang=js"
export * from "./OkidokiContractDialog.vue?vue&type=script&lang=js"
import style0 from "./OkidokiContractDialog.vue?vue&type=style&index=0&id=5248a650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5248a650",
  null
  
)

export default component.exports